import contentDialog from '~/mixins/dialogs/contentDialog'
import responsive from '~/mixins/pages/responsive'

const premiumPlan = {
  mixins: [contentDialog, responsive],
  methods: {
    showPremiumPreviewModal() {
      const hasToShowPremiumWelcome = this._.has(
        this.$localStorageClientData,
        'showPremiumWelcome',
        false
      )
      const showPremiumWelcome = this._.get(
        this.$localStorageClientData,
        'showPremiumWelcome',
        false
      )
      if (
        (!hasToShowPremiumWelcome || showPremiumWelcome) &&
        !this.xsDevice &&
        !this.$isRegistrationToday &&
        !this.$hasProVersion
      ) {
        this.contentDialog.open({
          width: '724px',
          component: 'm-block-welcome-premium',
          removePadding: true,
          onClose: () => {
            this.$setLocalStorageClientData({ showPremiumWelcome: false })
          }
        })
      }
    },
    showPremiumFeaturesModal(props = {}) {
      return this.contentDialog.open({
        width: '724px',
        component: 'm-block-premium-features-stepper',
        removePadding: true,
        componentProps: {
          ...props
        },
        onClose: () => {
          this.$setLocalStorageClientData({ showPremiumStepper: false })
        }
      })
    },
    showSavedRoutesModal() {
      const hasRoutesFeature = this._.has(
        this.$localStorageClientData,
        'showSavedParticipantsFeature',
        false
      )
      const showToRoutesFeature = this._.get(
        this.$localStorageClientData,
        'showSavedParticipantsFeature',
        false
      )
      if (this.$hasProVersion && (!hasRoutesFeature || showToRoutesFeature)) {
        return this.contentDialog.open({
          width: '724px',
          component: 'm-block-new-feature',
          removePadding: true,
          componentProps: {
            image: require('~/assets/images/premium/saved-participants-route-screen.png'),
            title: this.$t('Saved routes'),
            subtitle: this.$t(
              'Create routes for regular recipients and save time on future deliveries'
            ),
            features: [
              {
                icon: require('~/assets/images/icons/document-pencil-icon.png'),
                title: this.$t('Create one time'),
                description: this.$t('Saved collection of participants with roles')
              },
              {
                icon: require('~/assets/images/writing-hand.png'),
                title: this.$t('Use without limits'),
                description: this.$t(
                  'Select precreated route instead of manually create new each time'
                )
              },
              {
                icon: require('~/assets/images/icons/timer.png'),
                title: this.$t('Save your time'),
                description: this.$t('For the every document send')
              }
            ],
            buttonText: this.$t('Try now'),
            onButtonClick: () => {
              this.$setLocalStorageClientData({
                showSavedParticipantsFeature: false,
                savedParticipantsShownAt: this.$moment().toISOString()
              })
              this.contentDialog.close()
              this.$router.push({
                name: 'my-organizations-id-routes',
                params: { id: this.$Organization?.id }
              })
            },
            onClose: () => {
              this.$setLocalStorageClientData({
                showSavedParticipantsFeature: false,
                savedParticipantsShownAt: this.$moment().toISOString()
              })
            }
          },
          onClose: () => {
            this.$setLocalStorageClientData({
              showSavedParticipantsFeature: false,
              savedParticipantsShownAt: this.$moment().toISOString()
            })
          }
        })
      }
    },
    showAutoArchivationModal() {
      const hasAutoArchivationFeature = this._.has(
        this.$localStorageClientData,
        'showAutoArchivationFeature',
        false
      )
      const showAutoArchivationFeature = this._.get(
        this.$localStorageClientData,
        'showAutoArchivationFeature',
        false
      )
      if (this.$hasProVersion && (!hasAutoArchivationFeature || showAutoArchivationFeature)) {
        return this.contentDialog.open({
          width: '724px',
          component: 'm-block-new-feature',
          removePadding: true,
          componentProps: {
            image: require('~/assets/images/premium/auto-archivation-settings-screen.png'),
            title: this.$t('Auto archive documents'),
            subtitle: this.$t('No more manual actions – the system will do everything for you!'),
            features: [
              {
                icon: require('~/assets/images/icons/timer.png'),
                title: this.$t('Time saving'),
                description: this.$t(
                  'The system works automatically while you attend to important matters'
                )
              },
              {
                icon: require('~/assets/images/icons/gear-icon.png'),
                title: this.$t('Flexible rules'),
                description: this.$t(
                  'Configure archiving according to your needs: immediately after completion or after a certain period of time'
                )
              },
              {
                icon: require('~/assets/images/check-green.png'),
                title: this.$t('Always tidy'),
                description: this.$t(
                  'Completed items are automatically removed, but remain available in the archive'
                )
              }
            ],
            buttonText: this.$t('Setup auto archivation'),
            onButtonClick: () => {
              this.$setLocalStorageClientData({ showAutoArchivationFeature: false })
              this.contentDialog.close()
              this.$router.push({
                name: 'my-organizations-id-settings',
                params: { id: this.$Organization?.id },
                hash: '#archiving'
              })
            },
            onClose: () => {
              this.$setLocalStorageClientData({ showAutoArchivationFeature: false })
            }
          },
          onClose: () => {
            this.$setLocalStorageClientData({ showAutoArchivationFeature: false })
          }
        })
      }
    }
  }
}

export default premiumPlan
